import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToggleEventType, ToggleEventNameType, ToggleEventService } from '../../../services/toggle-event.service';
import { TraceService } from '../../../services/trace.service';
import { A11yModule } from '@angular/cdk/a11y';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TraceSuggestionsComponent } from "../trace-suggestions/trace-suggestions.component";

@Component({
  selector: 'tt-trace-xsmall-dialog-suggestions',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    TraceSuggestionsComponent
],
  templateUrl: './trace-xsmall-dialog-suggestions.component.html',
  standalone: true
})
export class TraceXsmallDialogSuggestionsComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription;
  protected data = inject<any>(MAT_DIALOG_DATA);
  constructor(
    private _toggleEventService: ToggleEventService,
    private _traceService: TraceService,
  ) { }
  ngOnInit(): void {
    this._subscriptions = new Subscription();

    this._subscriptions.add(
      this._toggleEventService.emitter$.subscribe((toggleEvent: ToggleEventType) => {
       if (toggleEvent.forwardedFor === 'trace' &&  toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
          this._traceService.closeSuggestionsDialog();
          // console.log('.............. close suggestions .................')
      }})
    );
  }
  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}